import * as Colorbox from './App/Colorbox';
import * as CarouselProgressBar from './App/CarouselProgressBar';

$(document).ready(function () {
    Colorbox.initialize();
    CarouselProgressBar.initialize();
});
